import { combineSlices } from '@reduxjs/toolkit';
import { apiMiscellaneousSlice } from '@vs/rtk/slices/apiMiscellaneous';
import { mvbSubscriptionPlanApiInjected } from '@vs/rtk/slices/apiMvbSubscription';
import { vsAccount2ApiSlice } from '@vs/rtk/slices/apiVsAccount2';
import { vsAuthApiSlice } from '@vs/rtk/slices/apiVsAuth';
import { vsCommonApiSlice } from '@vs/rtk/slices/apiVsCommon';
import { vsEntity2ApiInjected } from '@vs/rtk/slices/apiVsEntity2';
import { vsSubscriptionApiSlice } from '@vs/rtk/slices/apiVsSubscription';
import { generalStateSlice } from '@vs/rtk/slices/genericGlobal';

export const rootReducer = combineSlices(
  generalStateSlice,
  vsAccount2ApiSlice,
  vsCommonApiSlice,
  vsAuthApiSlice,
  vsSubscriptionApiSlice,
  apiMiscellaneousSlice,
  mvbSubscriptionPlanApiInjected,
  vsEntity2ApiInjected
);
